export const subscriptionApiErrorMessages = {
  currentBillingCycleStatusIsUnknown: 'No se puede cambiar la próxima fecha de pedido',
  rebillInProgress: 'No se puede cambiar la próxima fecha de pedido: refacturación en progreso',
  paymentFailed: 'No se puede cambiar la próxima fecha de pedido: fallo en el pago'
};
